"use client";

import { Suspense } from "react";

import type { PlpModalProps } from "../../hooks/usePlp";
import FilterModal from "./Filter";

const PlpModals = ({ filters, productCount }: PlpModalProps) => {
  return (
    <>
      <Suspense fallback="...">
        <FilterModal filters={filters} productCount={productCount} />
      </Suspense>
    </>
  );
};

export default PlpModals;
